import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { ViewAttachement_ImageModal } from '../../../zInternal_Features/merchant/components/Modal_ViewAttachement_Image';

//import classes from './Modal_ViewModal.module.css';
import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewScopeExpensesModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [viewScopeExpenses, setViewScopeExpenses] = useState([]);

    let [consultationID, setConsultationID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);

    let [viewAttachemntModal, setViewAttachemntModal] = useState(false);

    useEffect(() => {



        if(props.openModal == true && startDate != null && endDate != null)
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_scopeExpense_list',
                    user: acctID,
                    xConsultationID: props.data.consultationID,
                    xScopeNumber: props.data.scopeNumber,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {

                    let cols = rows[rownum].split('|');

                    let cols_expenses = cols[2].split('$');

                    setViewScopeExpenses((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            consultationID: cols_expenses[0],
                            scopeNumber: cols_expenses[1],
                            expenseLineNumber: cols_expenses[2],
                            itemID: cols_expenses[3],
                            itemName: cols_expenses[4],
                            itemDescription: cols_expenses[5],
                            itemQuantity: cols_expenses[6],
                            itemPrice: parseFloat(cols_expenses[7]).toFixed(2),
                            paymentType: cols_expenses[8],
                            attachement: cols_expenses[9],

                        })
                    });
                } 
            })
        }
    }, [props.openModal]);


    function closeModalHandler(event) {

        setViewScopeExpenses([]);
        props.closeModal(event);
    }
 


    return (

        <React.Fragment> 
           
            {props.openModal == true ?
            (
                <div>
                {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))}

                <IonModal isOpen={ props.openModal }>
                    <IonHeader className='appModalHeader'>
                        <h3>EXPENSES</h3>
                    </IonHeader>

                    <IonContent >
                        <IonGrid className='appGridContent'>
                                <IonRow class='gridResultHeaders'>
                                    <IonCol size='4' class='gridResultColumns'>Item Name</IonCol>
                                    <IonCol size='4' class='gridResultColumns'>Price</IonCol>
                                    <IonCol size='4' class='gridResultColumns'>Action</IonCol>
                                </IonRow>
                            {viewScopeExpenses.map((detailData1) =>   {
                                    return (
                                            <IonRow key={detailData1.estimateLineNumber}>
                                                <IonCol size='4'>{detailData1.itemName}</IonCol>
                                                <IonCol size='4'>{detailData1.itemPrice}</IonCol>
                                                <IonCol size='4'>

                                                <ViewAttachement_ImageModal openModal={ viewAttachemntModal } closeModal={() => setViewAttachemntModal(false)} data={{
                                                    paymentType: detailData1.paymentType, 
                                                    totalAmount: detailData1.totalAmount, 
                                                    fileLocation: detailData1.attachment, 
                                                    }}></ViewAttachement_ImageModal>
                                                    <IonButton className='appListButton' onClick={() => setViewAttachemntModal(true)}> View </IonButton>
                                            
                                                </IonCol>
                                            </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>

                    </IonContent>

                    <IonFooter className='modal_footer_button_center'>
                        <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                    </IonFooter>

                </IonModal>            
            </div>
            ) : null }

        </React.Fragment>

    )
}